import classNames from 'classnames';
import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { UI_RichText } from 'ui/components/1-atoms/RichText/RichText';
import styles from './BookmarkMenu.module.scss';
import { UI_Icon } from 'ui/components/1-atoms/Media/Icon/Icon';
import Arrow from 'ui/icons/icon-diagonal-arrow.svg';

export interface BookmarkMenuProps {
	className?: string;
	kicker?: string;
	heading?: string;
	text?: string;
	bookmarkItems: BookmarkItemProps[];
}

interface BookmarkItemProps {
	id?: string;
	title: string;
}

export const UI_BookmarkMenu = ({ className, kicker, heading, text, bookmarkItems }: BookmarkMenuProps) => {
	if (!bookmarkItems || bookmarkItems.length < 1) return null;

	return (
		<div className={classNames(styles.BookmarkMenu, className)}>
			{kicker && <div className={styles.BookmarkMenu_kicker}>{kicker}</div>}
			{heading && (
				<UI_Heading headingLevel="h2" className={styles.BookmarkMenu_heading}>
					{heading}
				</UI_Heading>
			)}
			{text && <UI_RichText className={styles.BookmarkMenu_text} content={text} />}
			<ul className={styles.BookmarkMenu_items}>
				{bookmarkItems.map((bookmarkItem: BookmarkItemProps, index) => (
					<li key={index} className={styles.BookmarkMenu_item}>
						{bookmarkItem.id ? (
							<UI_Link url={`#${bookmarkItem.id}`} className={styles.BookmarkMenu_itemLink} title={bookmarkItem.title}>
								<UI_Icon className={styles.BookmarkMenu_itemLinkIcon} size="sm">
									<Arrow />
								</UI_Icon>
								<span>{bookmarkItem.title}</span>
							</UI_Link>
						) : (
							<p className={styles.BookmarkMenu_itemLink}>{bookmarkItem.title}</p>
						)}
					</li>
				))}
			</ul>
		</div>
	);
};
